<div class="summary-panel">
  <div class="panel">
    <div class="detail">
      <div class="icon">
        <lds-icon name="briefcase" size="md" appearance="inherit"></lds-icon>
      </div>
      <div class="name">{{ companySummary.name }}</div>
      <div *ngIf="contactDeletionEnabled" class="action" (click)="delete()">
        <lds-icon name="remove" appearance="inherit"></lds-icon>
      </div>
    </div>
  </div>
</div>